import {Dispatch, useEffect, useState} from 'react';

type UseLocalStorageResult<T extends unknown> = [T, Dispatch<T>];

/**
 *
 * @param key
 * @param initialValue
 */
const useLocalStorage = <T>(key: string, initialValue: T): UseLocalStorageResult<T> => {
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  useEffect(() => {
    // Update storage every time the value is changed
    window.localStorage.setItem(key, JSON.stringify(storedValue));
  }, [storedValue, key]);

  return [storedValue, setStoredValue];
};

export default useLocalStorage;
